<template>
  <select
    v-model="selectedGroups"
    class="custom-select"
    :disabled="disabled"
    multiple
  >
    <option value="me">
      Just me
    </option>
    <option value="all">
      Share with entire team
    </option>
    <option
      v-for="group in groups"
      :value="group.hash_id"
    >
      Share with {{ group.name }}
    </option>
  </select>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'GroupsPicker',
  props: {
    modelValue: {
      type: Array,
      default: () => ['me'],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectedGroups = computed({
      get() {
        return props.modelValue
      },
      set(newVal) {
        let res = newVal
        if (newVal.length > 1 && newVal[0].match(/^(me|all)$/)) {
          res = newVal.slice(0, 1)
        }

        emit('update:modelValue', res)
      },
    })

    return {
      selectedGroups,
    }
  },
  computed: {
    groups() {
      return this.$store.state.TeamGroups.data
    },
  },
  mounted() {
    this.$store.dispatch('TeamGroups/loadData', {})
  },
}
</script>
